module.exports = __webpack_public_path__ + "assets/img/mp4.eb6baddf.png";